var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loaded)?_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.loaded}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }